import { render, staticRenderFns } from "./MatrixMenu2.vue?vue&type=template&id=535bda76&"
import script from "./MatrixMenu2.vue?vue&type=script&lang=js&"
export * from "./MatrixMenu2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports